import React, { useEffect, useState } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom'
import Card from '../../components/Card/Card';
import DataTable from '../../components/DataTable/DataTable';
import { IColInfo } from '../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import DataService from "../../services/data.service";

const ItemTypes: React.FC = () => {
    const [data, setData] = useState<any[]>();
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForItemType } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        getTableData();
    }, []);

    function getTableData() {
        DataService.get<any[]>('api/v1/itemtypes')
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function add() {
        navigate('/plm/itemsetup/itemtype/add', { state: { title: 'New item type', fromMenu: false } });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/ItemType/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    function canDeleteRow(rowData) {
        if (isAuthorizedForItemType(ApplicationFunctions.EditItemType, rowData.id))
            return true;

        return false;
    }


    const colInfos: IColInfo[] = [
        { title: 'ID', key: true, dataProp: 'id', dataType: 'number' },
        { title: 'Code', dataProp: 'code', filterInfo: { filterType: 'Textbox' } },
        { title: 'Name', dataProp: 'name', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
        { title: 'Begin date', dataProp: 'beginDate', dataType: 'date', width: 120, align: 'right' },
        { title: 'End date', dataProp: 'endDate', dataType: 'date', width: 120, align: 'right' },
    ];
    if (isAuthorizedForItemType(ApplicationFunctions.EditItemType)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: add }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow, isVisible: canDeleteRow }]
            });
    }

    return (
        <>
            <div className='main-content'>
                <Container fluid>
                    <Row>
                        <Col md={12}>
                            <Card title='Item types'
                                content={
                                    <DataTable
                                        name='dtItemTypes'
                                        tableData={data}
                                        colInfos={colInfos}
                                        navigateTitle='Item type'
                                        navigateUrl='/plm/itemsetup/itemtype/'
                                    />
                                }
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}
export default ItemTypes;